import { api } from "api";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { forkRoute } from "./fork";
import { forkListRoute } from "./fork-list";
import monitoringRoute from "./monitoring";
import newForkRoute from "./new-fork";
import optimistRoute from "./optimist";
import RootRoute from "./RootRoute";
import sdkRoute from "./sdk";
import taskDefinitionsRoute from "./task-definitions";
import { whitelistRoute } from "./whitelist";

export const rootRoute: RouteObject = {
  element: <RootRoute />,
  loader: () => api.version(),
  children: [
    {
      index: true,
      element: <Navigate to="/forks" replace={true} />,
    },
    {
      path: "/forks",
      ...forkListRoute,
    },
    {
      path: "/new-fork",
      ...newForkRoute,
    },
    {
      path: "/forks/:executionId",
      ...forkRoute,
    },
    {
      path: "optimist",
      ...optimistRoute,
    },
    {
      path: "task-definitions",
      ...taskDefinitionsRoute,
    },
    {
      path: "whitelist",
      ...whitelistRoute,
    },
    {
      path: "monitoring",
      ...monitoringRoute,
    },
    {
      path: "sdk",
      ...sdkRoute,
    },
  ],
};
